import React from "react";
import Card from "react-bootstrap/Card";
import Topbar from "../../components/Topbar";
import Button from "react-bootstrap/Button";
import Nav from "react-bootstrap/Nav";

// This component serves as a template for individual
// lesson pages.

/**
 * Template for a lesson page
 * Copy and paste this to create a new lesson page
 */
class LessonTemp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Title of the lesson",
      length: "Length of the lesson",
      description: "Description of the lesson",
      topics: ["Topic 1", "Topic 2", "Topic 3"],
      page: "../lessons/page",
    };
  }

  render() {
    return (
      <div className="lesson" style={{ backgroundColor: "#727c8f" }}>
        <Topbar />
        <div style={{ height: "1vh" }}></div>
        <div className="d-flex justify-content-center">
          <Card>
            <Card.Header className="bg-success text-white text-center">
              <h3>{this.state.title}</h3>
            </Card.Header>
            <Card.Body style={{ maxWidth: "75vw" }}>
              <div className="text-center">
                <Card.Title>Lesson Length: {this.state.length}</Card.Title>
              </div>
              <div style={{ height: "1vh" }}></div>
              {/**
               * Lesson content goes here
               */}
              <div style={{ height: "1vh" }}></div>
              <div className="d-flex justify-content-center">
                <Nav>
                  <Nav.Link href="../lessons" variant="dark">
                    <Button variant="info">Return to Lessons</Button>
                  </Nav.Link>
                </Nav>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }
}

export default LessonTemp;

export function Nice() {
  return <div>nice</div>;
}
